// extracted by mini-css-extract-plugin
export default {"menuBtn":"BubbleMenu__menuBtn--iqzbf"};